import React from 'react';

import fergusonThumb from '../assets/fergusonThumb.jpg';
import introThumb from '../assets/introThumb.jpg';
const MoreToRead = () => {
  return (
    <div className="more">
      <div className="more__header">
        <p className="subheadSB">More to read</p>
      </div>
      <a
        href="https://sponsorcontent.cnn.com/interactive/microsoft/intel/hybridcloud/mountaintopview/"
        target="_blank"
        rel="sponsored"
      >
        <div className="more__articleBox">
          <div className="article">
            <img src={fergusonThumb} alt="blue tower" />
            <div className="paragraph">
              <p className="moreP">A mountaintop view across a sprawling IT landscape</p>
            </div>
            <div className="buttonCont">
              <button className="readButton">Read Article</button>
            </div>
          </div>
        </div>
      </a>
      <a
        href="https://sponsorcontent.cnn.com/interactive/microsoft/intel/hybridcloud/bridgetoinnovation/"
        target="_blank"
        rel="sponsored"
      >
        <div className="more__articleBox">
          <div className="article">
            <img src={introThumb} alt="blue tower" />
            <div className="paragraph">
              <p className="moreP">In the hybrid cloud, innovation and security go hand in hand</p>
            </div>
            <div className="buttonCont">
              <button className="readButton">Read Article</button>
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};

export default MoreToRead;
